import { SolarType } from '../CommonTypes';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

export const fetchSolar = async (company: string, siteId: string) => {
  if (process.env.NODE_ENV === 'development') console.log('fetching solar', siteId, company);

  const colRef = query(collection(db, `${company}/${siteId}/solar`), orderBy('order'));

  const results = await getDocs(colRef);

  return results.docs.map(doc => {
    const data = doc.data() as SolarType;

    return { ...data, id: doc.id } as SolarType;
  });
};
